import script from "./UIReportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./UIReportButton.vue?vue&type=script&setup=true&lang=js"

import "./UIReportButton.vue?vue&type=style&index=0&id=824adca0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-824adca0"]])

export default __exports__